import React, { useState , useEffect } from 'react';
import { Button, Modal, ModalBody, ModalHeader, ROw, Col, Input, Label } from 'reactstrap';
//import images

import Select_new_DB_modal from './Select_New_DB_Modal';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {  close_select_db_modal, open_select_db_modal } from '../../../slices/Select_DB_Modal/reducer';
import { Create_Bot_Database_Structure, Create_New_Bot, GET_DB_Connection, GET_Sample_Db_Connection_List, Insert_Sample_Db_Connection_In_Group } from '../../../slices/thunks';
import DB_List from './Selected_DB_Connection_Modal_Component/DB_List';
import config from '../../../config';
import { useNavigate } from 'react-router-dom';
import Loader from '../Loader';
import { base64ToFile } from '../../../slices/layouts/utils';

const SelectDBConnectionModal = () => {
    const select_db_modal_state = useSelector((state)=> state.Select_DB_Modal)
    const create_bot_details = useSelector((state)=> state.Create_Bot)
    const [_selected_sample_DB, set_selected_sample_DB] = useState(null)
    const navigate = useNavigate()

    const dispatch = useDispatch()
  
  const [modal_grid, setmodal_grid] = useState(select_db_modal_state.db_select_modal_open);
  
    function select_db() {
        if(!modal_grid){
            dispatch(open_select_db_modal())
        }else{
            dispatch(close_select_db_modal())
        }
        setmodal_grid(!modal_grid);
    }

    useEffect(()=>{

       
     
        setmodal_grid(select_db_modal_state.db_select_modal_open)
    
    
      },[select_db_modal_state])


      useEffect(() => {

        
        if(create_bot_details.Group){

            dispatch(GET_DB_Connection({ group_id:create_bot_details.Group }))
            dispatch(GET_Sample_Db_Connection_List()) 
            set_selected_sample_DB(null)  
        }


      }, [create_bot_details.Group])




      const onChange_Sample_Db_Connection = (e) =>{
           set_selected_sample_DB(e.target.value);
           dispatch(Insert_Sample_Db_Connection_In_Group({Group_ID:create_bot_details.Group , SampleDB_ID:e.target.value})) 
      }


      



  
      


    

  return (
    <>
    {/* <Button color="primary" onClick={() => select_db()}> Launch Demo Modal</Button> */}
      <Modal
          size="lg"
        isOpen={modal_grid}
        toggle={() => {
          select_db();
        }}
            >
                <ModalHeader className="modal-title" toggle={() => {
                    select_db();
                }}>
                    Select DB connection

                </ModalHeader>
                <ModalBody>
                    { create_bot_details.loading   ? <Loader/> :<div className="row g-3">
                      <Col lg={12}>
                      <div className="listjs-table table-responsive table-card">
                            <table className="table align-middle table-nowrap table-striped-columns mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th className="" data-sort="" scope="col" style={{ width: "46px" }}>
                                            {/* <div className="form-check">
                                                <input className="form-check-input" type="checkbox" value="" id="cardtableCheck" />
                                                <label className="form-check-label" htmlFor="cardtableCheck"></label>
                                            </div> */}
                                        </th>
                                        <th className="sort" data-sort="connection_name" scope="col">Connection Name</th>
                                        <th className="sort" data-sort="db_type" scope="col">DB type</th>
                                        <th className="sort" data-sort="host" scope="col">Host</th>
                                        <th className="sort" data-sort="port" scope="col">Port</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {
                                        select_db_modal_state.DB_List?.connection?.map((ele,i)=>{
                                          
                                              return  <DB_List ele={ele} />
                                        })
                                    }
                                   
                                </tbody>
                            </table>
                        </div>                        
                      </Col>     
                      <Col lg={12}>
                      <div className='sndb' style={{margin: "10px 0px 0px 0px",display: 'flex',gap: '10px',alignItems: 'center', justifyContent: 'space-between'}}>
                          <Select_new_DB_modal />
                          <p style={{marginBottom: '0px'}}> Or select from sample DB</p>

                          <select onChange={onChange_Sample_Db_Connection} className="form-select rounded-pill mb-3" aria-label="Default select example">
                          <option>Select Sample DB</option>
                          {
                            select_db_modal_state.Sample_DB_List.map((ele,i)=>{
                               return <option  key={i} value={ele.SampleDB_ID}>{ele.Database_Name}</option>
                               
                            })
                          }
                            
                        </select>
                        </div>
                      </Col>                      
                        <Col lg={12}>
                            <div className="hstack gap-2 justify-content-end">
                                <Button className="rounded-pill " color="light" onClick={() => {
                                    setmodal_grid(false)
                                    dispatch(close_select_db_modal())
                                    
                                    }}>Cancel</Button>
                                <Button onClick={()=>{
                                    if( select_db_modal_state.database_id ){
                                        // console.log(base64ToFile(JSON.parse(create_bot_details.Bot_Logo)));
                                        
                                      dispatch(
                                        Create_New_Bot(
                                          {
                                          Group_ID: create_bot_details.Group,
                                          title: create_bot_details.Bot_Name,
                                          description:create_bot_details.Bot_Description,
                                          model: create_bot_details.Model,
                                          type: create_bot_details.Knowledge_base_type,
                                          bot_logo:base64ToFile(JSON.parse(create_bot_details.Bot_Logo)),
                                          database_id:select_db_modal_state.database_id,
                                          Query_Model:create_bot_details.SQL_Model,
                                          Embedding_Model:create_bot_details.Embedding_Model
                                        }
                                        ,navigate)
                                      );


                                      // dispatch(
                                      //   Create_Bot_Database_Structure({
                                      //     databaseId: select_db_modal_state.database_id,
                                      //     Group_ID: create_bot_details.Group,
                                      //     max_record: config.general_config.max_records,
                                      //     bot_allow_see_source: config.bot_allow_see_source,
                                      //     BOT_Category: create_bot_details.BOT_Category,
                                      //     Bot_Sample_Question:create_bot_details.Sample_Question, // ask khalid sir to add in combine 
                                      //     model: create_bot_details.Model,
                                      //     instructions:create_bot_details.Instruction,
                                      //     title: create_bot_details.Bot_Name,
                                      //     description: create_bot_details.Bot_Description,
                                      //     structure: [],
                                      //   },navigate)

                                         
                                      // );

                                      dispatch(close_select_db_modal())

                                      setmodal_grid(!modal_grid)
                                    }
                                }} className="rounded-pill " color="primary" >Next</Button>
                            </div>
                        </Col>
                    </div>}
                </ModalBody>
            </Modal>
    </>
  )
}

export default SelectDBConnectionModal
